import ApplyRounding from '../../../../../../../utils/math/ApplyRounding';

export function parseBreakNotificationDetails(notification) {
  const setupString = 'Break';
  const triggerPrice = ApplyRounding(
    notification.statusDetails.triggerPrice,
    2
  );
  
  return {
    tactic: setupString,
    price: '$' + triggerPrice,
  };
}
